module.exports = __webpack_public_path__ + "static/media/kira_tran.98d27403.png";